export default {
      id: "delete-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#delete-usage",
      toString: function () {
        return this.url;
      }
    }